import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false
    }

    componentDidMount () {
        Service.event.onFetchReceivedPackagesBySource.add((chartData) => {
            this.setState({
                histogramChartCategoriesList: chartData.categoryList,
                histogramChartSeriesDataList: chartData.seriesDataList,
                renderChart : true
            });
        });

        Service.fetchReceivedPackageStatsBySource(30);
    }

    componentWillUnmount() {

    }

    render() {

        const options = {
            title: {
                text: 'Receive Packages by Source for the last 30 days'
            },
            xAxis: {
                categories: this.state.histogramChartCategoriesList
            },
            yAxis: {
                title: {
                    text: 'Receive Packages by Source'
                }
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                    }
                }
            },
            series: [{
                name: 'Receive Packages by Source over last 30 days',
                type: 'column',
                colorByPoint: true,
                data: this.state.histogramChartSeriesDataList
            }]
        };

        return (
            <div>
                { this.state.renderChart ? <CustomChart options={options}/> : '' }
            </div>
        );
    }
}

export default ChartView;